// components/WebsiteListing.js — a member's logo and listing on the public website.  [marker: website-feed v1]
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function WebsiteListing({ member, canEdit, onChanged }) {
  const [busy, setBusy] = useState(false);
  const shown = member.show_on_website !== false;
  const listed = ['active', 'grace_period'].includes(member.status);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append('file', file);
      await api.post(`/website/businesses/${member.id}/logo`, fd, { headers: { 'Content-Type': undefined } });
      toast.success('Logo saved. It shows on the website within a few minutes.'); onChanged();
    } catch (err) { toast.error(err.response?.data?.error || 'The logo could not be saved.'); }
    finally { setBusy(false); }
  };
  const remove = async () => {
    setBusy(true);
    try { await api.delete(`/website/businesses/${member.id}/logo`); toast.success('Logo removed.'); onChanged(); }
    catch (err) { toast.error(err.response?.data?.error || 'Could not remove the logo.'); }
    finally { setBusy(false); }
  };
  const toggle = async () => {
    setBusy(true);
    try { await api.put(`/website/businesses/${member.id}/listing`, { showOnWebsite: !shown }); toast.success(shown ? 'Hidden from the website.' : 'Shown on the website.'); onChanged(); }
    catch (err) { toast.error(err.response?.data?.error || 'Could not change it.'); }
    finally { setBusy(false); }
  };
  return (
    <div className="card" style={{ gridColumn: '1 / -1' }}>
      <div className="card-header"><span className="card-title">On the website</span></div>
      <div className="card-body" style={{ display: 'flex', gap: 20, alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{ width: 180, height: 110, border: '1px solid var(--gray-200)', borderRadius: 8, display: 'grid', placeItems: 'center', background: '#fff', padding: 8 }}>
          {member.logo_filename
            ? <img alt={`${member.business_name} logo`} src={`/api/public/media/logo/${encodeURIComponent(member.logo_filename)}`} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
            : <span style={{ fontSize: '0.8rem', color: 'var(--gray-400)', textAlign: 'center' }}>No logo yet<br />(the name shows instead)</span>}
        </div>
        <div style={{ flex: 1, minWidth: 220, fontSize: '0.85rem', color: 'var(--gray-600)', display: 'grid', gap: 8 }}>
          <div>
            {!listed ? 'Not on the website: only active members are listed.'
              : !shown ? 'Hidden from the website.'
              : <>Listed under <strong>{member.membership_type_name || 'Members'}</strong> on Our Members and the Directory.{' '}
                  {member.website ? <>The logo links to <a href={/^https?:/i.test(member.website) ? member.website : `https://${member.website}`} target="_blank" rel="noopener noreferrer">{member.website}</a>.</> : 'Add a website to make the logo clickable.'}</>}
          </div>
          {canEdit && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <label className="btn btn-secondary btn-sm" style={{ cursor: busy ? 'wait' : 'pointer' }}>
                {member.logo_filename ? 'Replace logo…' : 'Upload logo…'}
                <input type="file" accept="image/png,image/jpeg,image/webp" style={{ display: 'none' }} disabled={busy} onChange={e => { upload(e.target.files[0]); e.target.value = ''; }} />
              </label>
              {member.logo_filename && <button type="button" className="btn btn-ghost btn-sm" disabled={busy} onClick={remove}>Remove logo</button>}
              {listed && <button type="button" className="btn btn-ghost btn-sm" disabled={busy} onClick={toggle}>{shown ? 'Hide from website' : 'Show on website'}</button>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
